<template>
  {{ $t('employee.list') }} <UsersIcon class="w-4 h-4 ml-2 mr-2" />
  <LoadingIcon icon="three-dots" class="w-8 h-8" v-show="loading" />
  <ul v-show="!loading">
    <template v-for="employee in employees" :key="employee.uuid">
      <li v-if="this.selectedEmployees.includes(employee.uuid)">
        <router-link
          :to="{
            name: 'side-menu-employees-detail',
            params: { uuid: employee.uuid }
          }"
          tag="a"
        >
          <ArrowUpLeftIcon class="w-4 h-4 mr-1 ml-2" /> {{ employee.name }}
          {{ employee.lastname }}
        </router-link>
      </li>
    </template>
  </ul>
</template>

<script>
import { defineComponent } from 'vue'
import employeeApi from '../../services/employees/employee.api'

export default defineComponent({
  data() {
    return {
      employees: [],
      loading: true
    }
  },
  mounted() {
    employeeApi.getList(1, 100).then(
      response => {
        this.employees = response.data.data
        this.loading = false
      },
      error => {
        console.log(error)
        this.loading = false
      }
    )
  },
  props: {
    selectedEmployees: {
      type: Array,
      default: () => []
    }
  }
})
</script>
